var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariantMobileVr1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 49,
    viewBox: "0 0 28 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7008 11.0469L5.50427 6.39243L5.54416 10.0681L2.17379 9.02929C2.17379 6.8319 1.35612 5.11395 -1.91141e-06 4.69445L-2.11661e-06 2.67029e-05L20.7008 6.35248L20.7008 11.0469Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51763e-06 44.3074L15.5356 35.338L6.84046 30.2841C6.26211 29.9445 5.94302 29.3452 5.94302 28.7259L5.94302 18.1984C5.94302 14.9623 7.51852 12.8848 9.5527 11.9459C10.3504 11.5863 11.2279 11.4065 12.1054 11.4065C12.9829 11.4065 13.8604 11.5863 14.6581 11.9658C16.7322 12.9247 18.3675 15.0422 18.3675 18.2584L18.3675 20.7953L28 15.2619L28 19.377L17.6097 25.3499C17.3305 25.5697 16.9715 25.6895 16.5726 25.6895C15.5954 25.6895 14.7778 24.8905 14.7778 23.8917L14.7778 18.2584C14.7778 16.6403 14.0798 15.6415 13.1624 15.222C12.8234 15.0622 12.4644 14.9823 12.0855 14.9823C11.7265 14.9823 11.3675 15.0622 11.0484 15.202C10.1909 15.6015 9.53276 16.5803 9.53276 18.1984L9.53276 27.7071L20.0028 33.7999C20.2621 33.9597 20.4815 34.1794 20.661 34.4591C21.1396 35.3181 20.8404 36.4168 19.9829 36.8962L0 48.4225L2.51763e-06 44.3074Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.377 23.8916C15.377 24.5508 15.9154 25.0901 16.5735 25.0901C16.8328 25.0901 17.0522 24.9903 17.2715 24.8704L21.7188 22.2935L16.1747 22.7529C15.696 23.0326 15.377 23.4321 15.377 23.8916L15.377 23.8916Z",
    fill: "#C72D28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02479 5.35352L5.02479 2.417L0.796875 1.11854L0.796875 4.05506L5.02479 5.35352Z",
    fill: "#F6D900"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.597656 44.647L0.597656 47.3838L4.56632 45.1065L4.56632 42.3697L0.597656 44.647Z",
    fill: "#1E78B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariantMobileVr1);
export default __webpack_public_path__ + "static/media/variantMobileVR1.a70e32a9051fdd8e1fec1751d15e4729.svg";
export { ForwardRef as ReactComponent };